import type { RealtimeStatus } from "@a2z/realtime";
import { retryRealtimeConnection } from "@a2z/realtime/firebase";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { Button } from "@a2z/ui";

export function RealtimeNotice({ status, onRetry }: { status: RealtimeStatus; onRetry?: () => void }) {
  const t = useTranslations();
  if (status !== "degraded" && status !== "unconfigured") return null;
  return <div role="status" className="fixed inset-x-3 bottom-3 z-50 flex items-center justify-between gap-3 rounded-[var(--radius-card)] border border-[color:var(--border-light)] bg-[color:var(--surface)] p-3 text-card text-[color:var(--text-primary)] shadow-[var(--shadow-lg)]">
    {/* "unconfigured" is permanent for this build; "degraded" is an interruption. */}
    <span>{t(status === "unconfigured" ? keys.common.realtimeUnconfigured : keys.common.realtimeDegraded)}</span>
    <Button onClick={() => { onRetry?.(); retryRealtimeConnection(); }}>{t(keys.common.realtimeRetry)}</Button>
  </div>;
}
